<template>
  <div
    id="home"
    ref="mainView"
  >
    <div
      id="img-container"
      v-show="!showCube"
    >
      <img
        id="krishna-img"
        ref="mainImg"
        style="min-height: 250px"
        :src="checkIndexForSource()"
        alt="krishna image"
      >

    </div>
    <div
      id="3d-canvas"
      v-show="showCube"
    >
      <div id="loading">
        <div>
          <div>...loading...</div>
          <div class="progress">
            <div id="progressbar"></div>
          </div>
        </div>
      </div>
      <canvas
        id="c"
        style="width: 500px; min-height: 90vh"
      ></canvas>
    </div>
    <div
      id="control-buttons"
      ref="buttons"
      v-show="showAfterLoad"
    >

      <div
        class="bubble left"
        ref="bubbleFirstLine"
        v-show="showAfterLoad"
      >
        {{ firstLine }}
        <br />
        <span ref="bubbleSecLine">
          {{ secLine }}
        </span>
        <span> {{ checkIfLastLine() }} </span>
        <br>
        <div id="img-anchor-container">
          <a
            ref="urlAttached"
            v-show="hasLinkAttached || hasImgAttached"
            target="_blank"
          >
            <img
              ref="imgAttached"
              v-show="hasImgAttached"
              style="max-height: 100px;"
              :class="checkWidth()"
            >
          </a>
        </div>
      </div>

      <div id="controls-buttons-container">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              ref="prev"
              @click="prev"
              v-on="on"
            >
              <img
                class="button-icon"
                :src="getIcon('prev')"
                alt="backward-img"
              >
            </v-btn>
          </template>
          <span>{{ translate('go-backwards') }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              ref="autoPlay"
              @click="toggleAutoPlay"
              v-on="on"
            >
              <img
                class="button-icon"
                :src="getIcon('play-pause')"
                alt="play-pause-icon"
              >
            </v-btn>
          </template>
          <span>{{ translate('toggle-autoplay') }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              ref="next"
              @click="next"
              v-on="on"
            >
              <img
                class="button-icon"
                :src="getIcon('next')"
                alt="forward-img"
              >
            </v-btn>
          </template>
          <span>{{ translate('go-forwards') }}</span>
        </v-tooltip>
      </div>

      <audio
        ref="audio"
        v-show="showAfterLoad"
        controls
        autoplay
      ></audio>

    </div>

    <audio
      ref="audioInstructions"
      autoplay
      style="display: none;"
    ></audio>
    <audio
      ref="imageLinkAudio"
      style="display: none;"
      :src="getClickToOpenAudio()"
    >
    </audio>

    <!-- <div class="fb-share-button" data-href="http://krishna-disse.web.app/" data-layout="button" data-size="large"><a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Fkrishna-disse.web.app%2F&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore">Compartilhar</a></div> -->
  </div>
</template>

<script>
import icons from "../assets/base64icons.json"
import airtable from "../assets/airtable.js"
import { eventBus } from "../main.js"
import mixins from "../assets/mixins.js"
import lines from "../assets/krishnaLines.json"
import { OrbitControls } from "@/assets/js/custom-orbit-controls/ThreeOrbitControlsGizmo__OrbitControls.js"
import { OrbitControlsGizmo } from "@/assets/js/custom-orbit-controls/ThreeOrbitControlsGizmo__OrbitControlsGizmo.js"
import { SkeletonUtils } from "three/examples/jsm/utils/SkeletonUtils.js"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import * as THREE from "three/build/three.module.js"
import { mapGetters } from 'vuex'
import THREEx from "@/assets/js/threex"

export default {
  name: "Home",
  mixins: [mixins],
  components: {},
  watch: {
    volume(nv) {
      if (nv) {
        const v = nv * .01
        Object.values(this.audioFlute).forEach(audio => audio.volume ? audio.volume = v : null)
      }
    }
  },
  computed: {
    ...mapGetters(['volume']),
    showCube() {
      if (this.indexesToHideCube.indexOf(this.index + 1) > -1) {
        return false
      }
      return true
    },
    language() {
      if (this.lang) {
        this.changeSpriteText()
        return this.lang
      } else {
        this.checkLanguage()
      }
      return this.lang
    },
    gotFirstInteraction() {
      if (this.firstInteraction) {
        return true
      }
      return false
    },
  },
  destroyed() {
    this.intervals.increase.forEach((interval) => clearInterval(interval))
    this.intervals.reduce.forEach((interval) => clearInterval(interval))
    this.renderer.setAnimationLoop(null)
    cancelAnimationFrame(this.frameid)
    this.renderer.domElement.parentElement.removeChild(this.renderer.domElement)
  },
  mounted() {
    this.krishnaLines = lines

    if (this.$route.params.lang) this.lang = this.$route.params.lang
    else this.checkLanguage()

    if (location.href.indexOf("localhost") === -1) {
      this.playNavigationInstruction()
    } else {
      // this.playNavigationInstruction()
      this.playLines()
      this.$refs.buttons.style.pointerEvents = "all"
    }

    eventBus.$on("updateLanguage", this.setLang)

    this.$refs.audio.volume = 1

    document.body.addEventListener("click", this.handleInteraction)

    this.initFluteAudio()

    this.init3D()
  },
  data() {
    return {
      isLocalhost: window.window.location.href.indexOf("localhost") > -1,
      outlineClickableCylinder: null,
      canvas: null,
      fluteAudio: {},
      fluteOutline: null,
      fluteInterval: [],
      fluteOriginalColor: {},
      domEvents: null,
      flute: {},
      mouse: { x: 0, y: 0 },
      spriteTexture: null,
      messageContext: null,
      sprite: null,
      scene: null,
      frameid: null,
      intervals: {
        reduce: [],
        increase: [],
      },
      indexesToHideCube: [7, 15, 16, 17, 18, 19, 21, 22, 23, 24],
      showcube: true,
      showAfterLoad: false,
      errorMsg: null,
      index: 0,
      lang: null,
      secLine: null,
      autoPlay: window.location.href.indexOf("localhost") === -1 ? true : false,
      firstLine: null,
      krishnaLines: [],
      hasImgAttached: false,
      hasLinkAttached: false,
      firstInteraction: false,
      executeAfterInteraction: null,
      mouse: null,
      camera: null,
    }
  },

  methods: {
    createClickableCilinderAround() {
      const geometry = new THREE.CylinderGeometry(0.3, 0.3, 3.5, 32)
      const material = new THREE.MeshBasicMaterial({
        color: 0xffff00,
        opacity: 0,
        transparent: true,
      })
      const cylinder = new THREE.Mesh(geometry, material)
      cylinder.rotation.set(30.9, 50.3, 89.75)
      cylinder.position.set(0.3, 2.1, 0.5)

      window.cylinder = cylinder
      this.cylinder = cylinder
      scene.add(cylinder)
      this.addEventListener(cylinder)
    },
    initFluteAudio() {
      this.fluteAudio.audio1 = new Audio("../audio/flute/flute1.mp3")
      this.fluteAudio.audio2 = new Audio("../audio/flute/flute2.mp3")
      this.fluteAudio.audio3 = new Audio("../audio/flute/flute3.mp3")
      this.fluteAudio.audio4 = new Audio("../audio/flute/flute4.mp3")
      this.fluteAudio.audio5 = new Audio("../audio/flute/flute5.mp3")
      this.fluteAudio.audio6 = new Audio("../audio/flute/flute6.mp3")
      this.fluteAudio.index = 1
      window.fluteaudio = this.fluteAudio
    },
    traverse() {
      window.fluteKrishna.traverse((child) => {
        if (
          child.material &&
          child.material.name &&
          (child.material.name == "fluteSkin1" ||
            child.material.name == "fluteSkinDark")
        ) {
          this.flute[child.material.name] = child
        }
      })
      window.flute = this.flute
      Object.values(this.flute).forEach((mesh) => {
        this.fluteOriginalColor[mesh.material.name] = {
          color: mesh.material.color,
          emissive: mesh.material.emissive,
        }

        // this.addEventListener(mesh)
      })
    },
    createOutline() {
      const fluteGeometry = this.flute.fluteSkin1.geometry.clone(),
        outlineMaterial = new THREE.MeshBasicMaterial({
          color: 0xff0000,
          side: THREE.BackSide,
        }),
        outlineMesh = new THREE.Mesh(fluteGeometry, outlineMaterial)
      outlineMesh.position.set(0.7, -1.77, -0.125)
      outlineMesh.scale.multiplyScalar(0.5)
      outlineMesh.name = "fluteOutline"
      this.fluteOutline = outlineMesh
      window.outlineMesh = outlineMesh
      this.scene.add(outlineMesh)
    },
    addEventListener(mesh) {
      if (!this.isMobile()) {
        this.domEvents.addEventListener(
          mesh,
          "mouseover",
          (event) => {
            let interv = setInterval(() => {
              const colorName = Object.keys(THREE.Color.NAMES)[
                Math.ceil(Math.random() * 147)
              ]
              Object.values(this.flute).forEach((mesh) => {
                mesh.material.emissive.setColorName(colorName)
              })
            }, 1250)
            if (!this.fluteOutline) {
              this.createOutline()
            }
            this.fluteInterval.push(interv)
          },
          false
        )

        this.domEvents.addEventListener(
          mesh,
          "mouseout",
          () => {
            this.fluteOutline
              ? (this.scene.remove(this.fluteOutline),
                (this.fluteOutline = null))
              : null
            this.fluteInterval.forEach((interv) => clearInterval(interv))

            setTimeout(() => {
              Object.values(this.flute).forEach((mesh) => {
                const name = mesh.material.name,
                  originalEmissive = this.fluteOriginalColor[name].emissive,
                  originalColor = this.fluteOriginalColor[name].color
                mesh.material.emissive.set(originalEmissive)
              })
            }, 100)
          },
          false
        )

        this.domEvents.addEventListener(mesh, "click", (event) => {
          this.playFlute()
          this.mouse.x = (event.clientX / this.canvas.width) * 2 - 1
          this.mouse.y = -(event.clientY / this.canvas.height + 12) * 2 + 1
          console.log(`no mobile click event`)
        })
      }
    },
    onPointerLeave() {
      // console.log(`onPointerLeave`)
      this.scene.remove(this.fluteOutline)
      this.fluteOutline = null
    },
    // onPointerOut() {
    //   console.log(`onPointerOut`)
    //   this.scene.remove(this.fluteOutline)
    //   this.fluteOutline = null
    // },
    onPointerMove(event) {
      this.mouse.x = (event.clientX / this.canvas.width) * 2 - 1
      let y
      !this.isLocalhost
        ? (y = -(event.clientY / this.canvas.height - 0.17) * 2 + 1)
        : (y = -(event.clientY / this.canvas.height) * 2 + 1)
      this.mouse.y = y
      // console.log(`onPointerMove`, this.mouse.x, this.mouse.y)
      // this.raycaster.setFromCamera(this.mouse, this.camera)
      // this.normalizePerspective()
      // var intersects = this.raycaster.intersectObjects([
      //   ...Object.values(this.flute)
      // ])
      var intersects = this.raycaster.intersectObjects([this.cylinder])
      if (intersects && intersects[0] && intersects[0].point) {
        if (!this.fluteOutline) {
          this.createOutline()
        }
      } else {
        this.scene.remove(this.fluteOutline)
        this.fluteOutline = null
        // this.fluteOutline ? (
        //   this.scene.remove(this.fluteOutline),
        //   this.fluteOutline = null
        // ) : null
      }
    },
    pointerDown(event) {
      this.mouse.x = (event.clientX / this.canvas.width) * 2 - 1
      let y
      !this.isLocalhost
        ? (y = -(event.clientY / this.canvas.height - 0.17) * 2 + 1)
        : (y = -(event.clientY / this.canvas.height) * 2 + 1)
      this.mouse.y = y
      this.raycaster.setFromCamera(this.mouse, this.camera)
      // this.normalizePerspective()
      var intersects = this.raycaster.intersectObjects([
        // ...Object.values(this.flute)
        this.cylinder,
      ])
      if (intersects && intersects[0] && intersects[0].point) {
        this.playFlute()
        // console.log(`intercepted`, this.mouse.y)
        this.createOutline()
        setTimeout(() => {
          this.fluteOutline
            ? (this.scene.remove(this.fluteOutline), (this.fluteOutline = null))
            : null
        }, 5000)
      }
    },

    normalizePerspective() {
      var vector = new THREE.Vector3()
      vector.set(this.mouse.x, this.mouse.y, 0.5)
      vector.unproject(this.camera)
      this.raycaster.set(
        this.camera.position,
        vector.sub(this.camera.position).normalize()
      )
    },

    playFlute() {
      const currentAudio = this.fluteAudio[`audio${this.fluteAudio.index}`]
      if (currentAudio.readyState > 1) {
        currentAudio.play()
        if (this.fluteAudio.index === 6) this.fluteAudio.index = 1
        else this.fluteAudio.index++
      }
    },
    getMessage() {
      return this.lang == "pt" ? "Clique na flauta" : "Click the flute"
    },
    changeSpriteText() {
      // console.log(`change language - change sprite text`)
      this.messageContext.clearRect(0, 0, 640, 480)
      const message = this.getMessage(),
        metrics = this.messageContext.measureText(message),
        width = metrics.width

      this.getMessageContextParams(width)
      this.messageContext.fillText(message, 4, 20)
      this.spriteTexture.needsUpdate = true
    },
    getMessageContextParams(width) {
      this.messageContext.fillStyle = "rgba(0,0,0,0.95)" // black border
      this.messageContext.fillRect(0, 0, width + 8, 20 + 8)
      this.messageContext.fillStyle = "rgba(255,255,255,0.95)" // white filler
      this.messageContext.fillRect(2, 2, width + 4, 20 + 4)
      this.messageContext.fillStyle = "rgba(0,0,0,1)" // text color
    },
    increaseIntensity(eyes) {
      const increaseInterval = setInterval(() => {
        eyes[0].material.emissiveIntensity += 0.075
        eyes[1].material.emissiveIntensity += 0.075
        if (eyes[0].material.emissiveIntensity >= 0.9) {
          setTimeout(() => {
            this.intervals.increase.forEach((interval) =>
              clearInterval(interval)
            )
            this.reduceIntensity(eyes)
          }, 2500)
        }
        if (eyes[0].material.emissiveIntensity < 0.01) {
          eyes[0].material.emissiveIntensity = 0.2
          eyes[1].material.emissiveIntensity = 0.2
        }
      }, 115)
      this.intervals.increase.push(increaseInterval)
    },
    reduceIntensity(eyes) {
      const reduceInterval = setInterval(() => {
        eyes[0].material.emissiveIntensity -= 0.075
        eyes[1].material.emissiveIntensity -= 0.075
        if (eyes[0].material.emissiveIntensity <= 0.1) {
          this.intervals.reduce.forEach((interval) => clearInterval(interval))
          this.increaseIntensity(eyes)
        }
        if (eyes[0].material.emissiveIntensity > 1) {
          eyes[0].material.emissiveIntensity = 0.9
          eyes[1].material.emissiveIntensity = 0.9
        }
      }, 115)
      this.intervals.reduce.push(reduceInterval)
    },
    createEyeAnimation(eyes) {
      if (eyes[0].material.emissiveIntensity >= 0.1) {
        this.increaseIntensity(eyes)
      } else {
        this.reduceIntensity(eyes)
      }
    },
    initEyeAnimations() {
      const eyes = []
      fluteKrishna.traverse((child) => {
        if (child.isMesh) {
          if (
            child.material.name === "rightEye" ||
            child.material.name === "leftEye"
          ) {
            child.material.emissive.setColorName("white")
            child.material.emissiveIntensity = 0.3
            eyes.push(child)
            window.eyes = eyes
            if (eyes.length == 2) {
              // this.createEyeAnimation(eyes)
              // this.randomEyeColors()
            }
          } else if (child.material.name === "blackSkin") {
            window.blackSkin = child
          }
        }
      })
    },
    randomEyeColors() {
      window.changeColorInterval = setInterval(() => {
        const colorName = Object.keys(THREE.Color.NAMES)[
          Math.ceil(Math.random() * 147)
        ]
        window.eyes.forEach((eye) => {
          eye.material.emissive.setColorName(colorName)
          eye.material.color.setColorName(colorName)
        })
      }, 2000)
    },
    onDocumentMouseMove(event) {
      // update the mouse variable
      this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1
      this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1
      // console.log('this.mouse.x', this.mouse.x)
      // console.log('this.mouse.y', this.mouse.y)

      // update sprite position
      // this.sprite.position.set( this.mouse.x * -2, this.mouse.y * 5, 0 );
      // console.log({...this.sprite.position})
      // console.log('event.clientX', event.clientX)
      // console.log('event.clientY', event.clientY)
    },
    initTooltip() {
      const messageCanvas = document.createElement("canvas"),
        messageContext = messageCanvas.getContext("2d")
      messageContext.font = "Bold 20px Arial"
      this.messageContext = messageContext

      const message = this.getMessage(),
        metrics = messageContext.measureText(message),
        width = metrics.width

      this.getMessageContextParams(width)
      messageContext.fillText(message, 4, 20)
      // canvas contents will be used for a texture
      const texture1 = new THREE.Texture(messageCanvas)
      texture1.needsUpdate = true

      var spriteMaterial = new THREE.SpriteMaterial({
        map: texture1,
      })

      const sprite1 = new THREE.Sprite(spriteMaterial)
      sprite1.scale.set(1.5, 1, 0.1)
      sprite1.position.set(0.06, 2.05, 0)
      this.scene.add(sprite1)
      this.sprite = sprite1
      this.spriteTexture = texture1

      window.sprite = sprite1
      window.messageContext = messageContext
    },
    init3D() {
      const canvas = document.querySelector("#c"),
        renderer = new THREE.WebGLRenderer({ canvas, antialias: true })

        renderer.physicallyCorrectLights = true;
        renderer.outputEncoding = THREE.sRGBEncoding;
        renderer.setPixelRatio( window.devicePixelRatio );

      canvas.onmousemove = this.onDocumentMouseMove
      if (this.isMobile()) {
        canvas.onpointerdown = this.pointerDown
        canvas.onpointermove = this.onPointerMove
        canvas.onpointerleave = this.onPointerLeave
        canvas.onpointerout = this.onPointerOut
      }
      this.canvas = canvas

      this.renderer = renderer
      const fov = 21,
        aspect = canvas.width / canvas.height, // 10, // the canvas default
        near = 1,
        far = 2800,
        camera = new THREE.PerspectiveCamera(fov, aspect, near, far)
      // camera.position.set(1, 2, 15)
      camera.position.set(1.9, 2.1, 5.5)

      // x: 1.9367590257034437
      // y: 2.3567675522998086
      // z: 4.526494788293914

      window.camera = camera
      this.camera = camera

      const controls = new OrbitControls(camera, renderer.domElement)
      const controlsGizmo = new OrbitControlsGizmo(controls, {
        size: 100,
        padding: 8,
      })
      controls.ed.target.set(1, 2.6, 1)
      controls.ed.update()
      window.controls = controls

      const scene = new THREE.Scene()
      scene.background = new THREE.Color("white")

      this.scene = scene
      window.scene = scene

      this.raycaster = new THREE.Raycaster()
      this.mouse = new THREE.Vector2()

      function addLight(pos, intensity) {
        const color = 0xffffff
        const light = new THREE.DirectionalLight(color, intensity ? intensity : 1)
        light.position.set(...pos)
        scene.add(light)
        scene.add(light.target)
        window.lights.push(light)
      }
      window.lights = []
      addLight([5, 5, 2], 3)
      addLight([-5, 5, 5], 3)
      addLight([0, -5, 0])
      addLight([-1, 4, -4])

      // const light = new THREE.AmbientLight(0x404040) // soft white light
      // const light = new THREE.AmbientLight(0xffffff) // soft white light
      // scene.add(light)
      const pointLight = new THREE.PointLight(0xffffff, 2)
      scene.add(pointLight)
      window.pointLight = pointLight
      const manager = new THREE.LoadingManager()
      manager.onLoad = init

      this.domEvents = new THREEx.DomEvents(camera, renderer.domElement, THREE)

      const progressbarElem = document.querySelector("#progressbar")
      manager.onProgress = (url, itemsLoaded, itemsTotal) => {
        progressbarElem.style.width = `${
          ((itemsLoaded / itemsTotal) * 100) | 0
        }%`
      }

      const models = {
        // krishna: { url: `../models/krishna-cube-head3.glb` },
        // fluteKrishna: { url: '../models/krishna-peacock-feather-v2.glb'},
        fluteKrishna: { url: "../models/krishna-peacock-feather-v3.glb" },
      }

      this.model = models

      const glbLoader = new GLTFLoader(manager)
      for (const model of Object.values(models)) {
        glbLoader.load(
          model.url,
          (glb) => {
            model.glb = glb

            if (model.url.indexOf("cube") > -1) {
              model.glb.name = "cubeHead"
            } else if (model.url.indexOf("peacock") > -1) {
              model.glb.name = "flutePeacockKrishna"
              model.glb.scene.scale.multiplyScalar(0.4, 0.4, 0.4)
            }
          },
          undefined,
          function (error) {
            console.error(error)
          }
        )
      }

      function prepModelsAndAnimations() {
        Object.values(models).forEach((model) => {
          const animsByName = {}
          model.glb.animations.forEach((clip) => {
            animsByName[clip.name] = clip
          })
          model.animations = animsByName
        })
      }

      let root,
        localScope = this
      const mixerInfos = []

      function init() {
        // TBD
        // hide the loading bar
        const loadingElem = document.querySelector("#loading")
        loadingElem.style.display = "none"

        prepModelsAndAnimations()

        Object.values(models).forEach((model, index) => {
          if (model.glb) {
            const clonedScene = SkeletonUtils.clone(model.glb.scene)
            root = new THREE.Object3D()
            root.add(clonedScene)
            scene.add(root)

            if (index == 0) {
              root.position.x = 1
              root.position.y = -1
              window.fluteKrishna = root
              localScope.traverse()
            } else {
              root.position.x = 10
            }

            // root.rotation.y = 80.1

            const mixer = new THREE.AnimationMixer(clonedScene)

            const actions = Object.values(model.animations).map((clip) => {
              mixer.name = clip.name
              return mixer.clipAction(clip)
            })
            const mixerInfo = {
              mixer,
              actions,
              actionNdx: -1,
            }
            mixerInfos.push(mixerInfo)
            playNextAction(mixerInfo)

            localScope.createClickableCilinderAround()

            localScope.initEyeAnimations()

            localScope.initTooltip()
          }
        })

        {
          const planeSize = 30

          const loader = new THREE.TextureLoader()
          const texture = loader.load("../img/three/checker.png")
          texture.wrapS = THREE.RepeatWrapping
          texture.wrapT = THREE.RepeatWrapping
          texture.magFilter = THREE.NearestFilter
          const repeats = planeSize / 3
          texture.repeat.set(repeats, repeats)

          const planeGeo = new THREE.PlaneGeometry(planeSize, planeSize)
          const planeMat = new THREE.MeshPhongMaterial({
            map: texture,
            side: THREE.DoubleSide,
          })
          const mesh = new THREE.Mesh(planeGeo, planeMat)
          mesh.rotation.x = Math.PI * -0.5
          mesh.position.y = -1
          // scene.add(mesh)
        }
        setTimeout(() => {
          localScope.showAfterLoad = true
        }, 500)
        // if (!localScope.isMobile()) {
        //   document.body.appendChild(controlsGizmo.domElement)
        // }
      }

      function playNextAction(mixerInfo, actionIndex, modifier) {
        const { actions, actionNdx } = mixerInfo
        if (modifier) {
          actions.forEach((action, ndx) => {
            action.enabled = false
          })
          actions[actionIndex].enabled = true
          actions[actionIndex].play()
        } else {
          const nextActionNdx = (actionNdx + 1) % actions.length
          mixerInfo.actionNdx = nextActionNdx
          actions.forEach((action, ndx) => {
            const enabled = ndx === nextActionNdx
            action.enabled = enabled
            if (enabled) {
              action.play()
            }
          })
        }
      }

      function resizeRendererToDisplaySize(renderer) {
        const canvas = renderer.domElement
        const width = canvas.clientWidth
        const height = canvas.clientHeight
        const needResize = canvas.width !== width || canvas.height !== height
        if (needResize) {
          renderer.setSize(width, height, false)
        }
        return needResize
      }

      let then = 0
      let deltaTime = 0
      const render = (now) => {
        now *= 0.001 // convert to seconds
        deltaTime = now - then
        then = now

        if (resizeRendererToDisplaySize(renderer)) {
          const canvas = renderer.domElement
          camera.aspect = canvas.clientWidth / canvas.clientHeight
          camera.updateProjectionMatrix()
        }

        // for (const mixer of mixers) {
        for (const { mixer } of mixerInfos) {
          mixer.update(deltaTime)
        }

        renderer.render(scene, camera)

        this.frameid = requestAnimationFrame(render)
      }
      requestAnimationFrame(render)
    },

    isMobile() {
      return /Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    },

    getClickToOpenAudio(modifier) {
      if (this.language === "pt") {
        if (modifier === "load")
          this.$refs.audioInstructions.src = "/audio/clickToOpenLink-pt.m4a"
        else return "/audio/clickToOpenLink-pt.m4a"
      } else {
        if (modifier === "load")
          this.$refs.audioInstructions.src = "/audio/clickToOpenLink-en.m4a"
        else return "/audio/clickToOpenLink-en.m4a"
      }
    },

    // setHamburgerMenuAudio() {
    //   if (this.language === 'pt') {
    //     this.$refs.audioInstructions.src = '/audio/hamburger-menu-instruction-pt.m4a'
    //     this.firstLine = 'Clique no menu hamburger para descobrir os outros links'
    //   } else {
    //     this.$refs.audioInstructions.src = '/audio/hamburger-menu-instruction-en.m4a'
    //     this.firstLine = 'Click on the hambuger menu to find out the other links'
    //   }
    // },

    setNavInstructionAudio() {
      if (this.language === "pt") {
        this.$refs.audioInstructions.src =
          "/audio/navigation-instruction-pt.m4a"
        this.firstLine =
          "Clique na tela para iniciar a apresentação. Aumente o volume do seu dispositivo para ouvir o áudio. Caso não ouça o áudio aperte F5 para renovar a tela"
      } else {
        this.$refs.audioInstructions.src =
          "/audio/navigation-instruction-en.m4a"
        this.firstLine =
          "Click on the screen to start the presentation. Increase the device volume to hear the audio. In case the audio doesn´t play press F5 to refresh the screen"
      }
    },

    init() {
      this.$refs.audioInstructions.onplay = null
      this.$refs.audioInstructions.autoplay = false

      // this.setClickToOpenAudio()

      this.$refs.imageLinkAudio.onplay = () => {
        this.flashBorders("image")
      }
      this.$refs.buttons.scrollIntoView()
      this.playLines()
    },

    // hideShowCube() {
    //   (this.index + 1 === 7) {

    //   }
    // },

    checkIndexForSource() {
      if (this.index + 1 === 7) {
        this.showcube = false
        return "img/panca-tattva.jpg"
      } else if (this.index + 1 === 15) {
        this.showcube = false
        return "img/krishna-and-the-gopas-eating.jpg"
      } else if (this.index + 1 === 16) {
        this.showcube = false
        return "img/krishna-and-gopas-playing.jpg"
      } else if (this.index + 1 === 17) {
        this.showcube = false
        return "img/aghasura-demon.jpg"
      } else if (this.index + 1 === 18) {
        this.showcube = false
        return "img/kamsa-try-to-kill-devaki.jpg"
      } else if (this.index + 1 === 19) {
        this.showcube = false
        return "img/killing-of-kamsa-by-krishna.jpg"
      } else if (this.index + 1 === 21) {
        this.showcube = false
        return "img/bg-4-8.png"
      } else if (this.index + 1 === 22) {
        this.showcube = false
        return "img/hiranyakashipu-brahma.jpg"
      } else if (this.index + 1 === 23) {
        this.showcube = false
        return "img/hiranyakashipu-try-to-kill-prahlada.jpg"
      } else if (this.index + 1 === 24) {
        this.showcube = false
        return "img/hiranyakashipu-killed-by-nrsimhadeva.jpg"
      } else {
        this.showcube = true
        // return "img/krishna.jpg"
      }
    },

    toggleAutoPlay() {
      this.autoPlay = !this.autoPlay
      if (this.autoPlay) {
        this.checkConditionsAndPlay()
        this.$refs.audio.onplay = null
        this.$refs.audio.muted = false
        this.$refs.audio.style.pointerEvents = "all"
      } else {
        this.$refs.audio.onplay = () => this.$refs.audio.pause()
        this.$refs.audio.pause()
        this.$refs.audio.muted = true
        this.$refs.audio.style.pointerEvents = "none"
      }
    },

    async playNavigationInstruction() {
      this.$refs.audioInstructions.onplay = (event) => {
        if (
          this.$refs.audioInstructions.currentSrc.indexOf(
            "navigation-instruction"
          ) > -1
        ) {
          this.flashBorders()
        }
      }

      this.setNavInstructionAudio()

      this.$refs.audioInstructions.onpause = () => {
        if (this.$refs.audioInstructions.played.length > 0) {
          setTimeout(() => {
            this.$refs.audioInstructions.onplay = null
            this.$refs.audioInstructions.autoplay = false

            // this.setClickToOpenAudio()
            if (this.$refs.imageLinkAudio.readyState !== 4) {
              this.getClickToOpenAudio("load")
            }

            this.$refs.imageLinkAudio.onplay = () => {
              this.flashBorders("image")
            }
            this.$refs.buttons.scrollIntoView()
            this.playLines()
          }, 1500)
        }
      }

      setTimeout(async () => {
        if (
          this.gotFirstInteraction &&
          this.$refs.audioInstructions.played.length < 1 &&
          this.$refs.audioInstructions.currentSrc.indexOf(
            "navigation-instruction"
          ) > -1
        ) {
          if (this.$refs.audioInstructions.error) {
            this.setNavInstructionAudio()
          }
          await this.$refs.audioInstructions.play()
        } else if (
          this.$refs.audioInstructions.played.length === 0 &&
          this.$refs.audioInstructions.currentSrc.indexOf(
            "navigation-instruction"
          ) > -1
        ) {
          this.executeAfterInteraction = "play-navigation-instruction"
        } else {
          this.executeAfterInteraction = ""
        }
      }, 4000)
    },

    flashBorders(where) {
      if (where === "image") {
        const flashBorderInterval = setInterval(() => {
          if (this.$refs.imgAttached.style.border.length === 0) {
            this.$refs.imgAttached.style.border = "3px solid black"
          } else {
            this.$refs.imgAttached.style.border = ""
          }
        }, 300)

        setTimeout(() => {
          clearInterval(flashBorderInterval)
          this.$refs.buttons.style.border = ""
        }, 3000)
      } else if (where === "hamburger-menu") {
        // let htmlCollection = document.getElementsByClassName('md-ripple'), index = -1 //[3]
        // for (let el of htmlCollection) {
        //   index++
        //   for (let cl of el.classList) {
        //     if (cl != 'md-ripple') {
        //       break
        //     }
        //   }
        // }
        // const hamburgerMenu = htmlCollection[index],
        //   flashBorderInterval = setInterval(() => {
        // if (hamburgerMenu.style.border === '') {
        //   hamburgerMenu.style.border = '3px solid'
        // } else {
        //   hamburgerMenu.style.border = ''
        // }
        // }, 300)
        // setTimeout(() => {
        //   clearInterval(flashBorderInterval)
        //   hamburgerMenu.style.border = ''
        // }, 3000)
        // hamburgerMenu.scrollIntoView()
      } else {
        if (this.language === "pt") {
          this.firstLine = "Clique nos botões para efetuar a navegação"
        } else {
          this.firstLine = "Click on these buttons to perform navigation"
        }

        const flashBorderInterval = setInterval(() => {
          // this.$refs.autoPlay.$refs.link.style.border
          if (this.$refs.autoPlay.$refs.link.style.border.length === 0) {
            this.$refs.autoPlay.$refs.link.style.border = "2px solid"
          } else {
            this.$refs.autoPlay.$refs.link.style.border = ""
          }
          if (this.$refs.next.$refs.link.style.border.length === 0) {
            this.$refs.next.$refs.link.style.border = "2px solid"
          } else {
            this.$refs.next.$refs.link.style.border = ""
          }
          if (this.$refs.prev.$refs.link.style.border.length === 0) {
            this.$refs.prev.$refs.link.style.border = "2px solid"
          } else {
            this.$refs.prev.$refs.link.style.border = ""
          }
        }, 300)

        setTimeout(() => {
          clearInterval(flashBorderInterval)
          this.$refs.autoPlay.$refs.link.style.border = ""
          this.$refs.next.$refs.link.style.border = ""
          this.$refs.prev.$refs.link.style.border = ""
          this.$refs.buttons.style.pointerEvents = "all"
        }, 8000)

        this.$refs.buttons.scrollIntoView()
      }
    },

    checkImgWidth() {
      if (window.innerWidth < 768) {
        this.$refs.imgAttached.style.maxHeight = "60px"
        this.$refs.imgAttached.style.left = "10%"
      } else {
        this.$refs.imgAttached.style.maxHeight = "100px"
        this.$refs.imgAttached.style.left = "7%"
      }

      // if (this.hasImgAttached && window.innerHeight < 635) {
      //   this.$refs.mainView.classList.add('increase-min-height')
      //   // this.$refs.buttons.scrollIntoView()
      // } else {
      //   this.$refs.mainView.classList.remove('increase-min-height')
      // }
    },

    async checkIfImageToClick(e) {
      if (
        e.target &&
        e.target.tagName === "AUDIO" &&
        e.target.currentTime === e.target.duration
      ) {
        // if (this.hasImgAttached && this.hasLinkAttached && window.innerHeight < 595) {
        //   this.$refs.mainView.classList.add('increase-min-height')
        //   this.$refs.buttons.scrollIntoView()
        // } else {
        //   this.$refs.mainView.classList.remove('increase-min-height')
        // }

        if (
          this.hasImgAttached &&
          this.hasLinkAttached &&
          this.firstInteraction
        ) {
          if (this.$refs.imageLinkAudio.readyState === 4) {
            this.$refs.imageLinkAudio.play()
          } else {
            this.$refs.imageLinkAudio.oncanplaythrough = () =>
              this.$refs.imageLinkAudio.play()
            this.getClickToOpenAudio()
          }
        } else if (!this.firstInteraction) {
          this.executeAfterInteraction = "play-click-to-open-link"
        }
      }
    },

    checkWidth() {
      if (window.innerWidth < 768) {
        return "center-image"
      }

      return null
    },

    async handleInteraction(event) {
      this.firstInteraction = true

      if (this.executeAfterInteraction && this.autoPlay) {
        switch (this.executeAfterInteraction) {
          case "play-navigation-instruction":
            if (this.$refs.audioInstructions.error) {
              this.setNavInstructionAudio()
            }
            await this.$refs.audioInstructions.play()
            this.$refs.audioInstructions.onpause = () => {
              this.playLines()
            }
            break

          case "play-audio":
            if (this.$refs.audio.played.length < 1) {
              this.checkConditionsAndPlay()
            }
            break

          case "play-click-to-open-link":
            if (
              this.$refs.imageLinkAudio.error ||
              this.$refs.imageLinkAudio.readyState !== 4
            ) {
              this.$refs.imageLinkAudio.oncanplaythrough = () =>
                this.$refs.imageLinkAudio.play()
              this.getClickToOpenAudio()
            }
            // await this.$refs.audioInstructions.play()
            break

          default:
            break
        }
        document.body.removeEventListener("click", this.handleInteraction)
      }
    },

    async checkConditionsAndPlay() {
      if (this.$refs.audio.src.indexOf("null") > -1 || this.$refs.audio.error) {
        if (this.krishnaLines[this.index].attachment.length > 0) {
          for (let att of this.krishnaLines[this.index].attachment) {
            if (att.type.indexOf("audio") > -1) {
              this.$refs.audio.onpause = (event) => {
                this.checkIfImageToClick(event)
              }
              if (att.filename.indexOf(`l${this.index + 1}-both`) > -1) {
                this.$refs.audio.src = att.url
                break
              } else if (
                this.language === "pt" &&
                att.filename.indexOf(`l${this.index + 1}pt`) > -1
              ) {
                this.$refs.audio.src = att.url
                break
              } else if (
                this.language === "en" &&
                att.filename.indexOf(`l${this.index + 1}en`) > -1
              ) {
                this.$refs.audio.src = att.url
                break
              }
            }
          }
        }

        if (this.$refs.audio.error) {
          this.checkConditionsAndPlay()
        } else {
          await this.$refs.audio.play()
        }
      } else {
        if (this.$refs.audio.error) {
          this.checkConditionsAndPlay()
        } else {
          await this.$refs.audio.play()
        }
      }
    },

    prev() {
      if (this.index > 0) {
        this.index -= 1
      } else {
        this.index = this.krishnaLines.length - 1
      }
      this.playLines()
    },

    next() {
      if (this.index < this.krishnaLines.length - 1) {
        this.index += 1
      } else {
        this.index = 0
      }

      this.playLines()
    },

    checkIfLastLine() {
      if (this.index === this.krishnaLines.length - 1) {
        if (this.language === "pt") {
          return "O fim"
        } else {
          return "The end"
        }
      }
    },

    translate(section) {
      switch (section) {
        case "click-to-play-audio":
          if (this.language === "pt")
            return "Clique para tocar novamente a voz de Krishna"
          else return "Click to play again Krishna´s voice"

        case "toggle-autoplay":
          if (this.language === "pt") {
            if (this.autoPlay) return "Desabilitar tocar audio"
            else return "Habilitar tocar audio"
          } else {
            if (this.autoPlay) return "Disable play audio"
            else return "Enable play audio"
          }

        case "go-backwards":
          if (this.language === "pt") return "Retroceder fala"
          else return "Go backwards"

        case "go-forwards":
          if (this.language === "pt") return "Avançar fala"
          else return "Go forward"

        case "krishna-said":
          if (this.language === "pt") return "Krishna disse"
          else return "Krishna said"

        case "site-description":
          if (this.language === "pt")
            return "Esse site foi criado com intuito de promover a propagação do Movimento do Canto Congregacional dos Cantos dos Nomes de Krishna (Deus) iniciado por Sri Caitanya Mahaprabhu há 500 anos"
          else
            return "This website was created in order to promote the spread of the Movement of the congregational chanting of the Names of Krishna (God) started by Sri Caitanya Mahaprabhu 500 years ago"

        case "golokera-prema-dhan":
          if (this.language === "pt")
            return "Golokera Prema Dhan - Harinam Sankirtan - O Néctar do Cantar dos Nomes de Deus"
          else
            return "Golokera Prema Dhan - Harinam Sankirtan - The Nectar of Chanting the Holy Names of God"

        case "share-on-social-media":
          if (this.language === "pt") return "Compartilhe"
          else return "Share"
        //
        default:
          break
      }
    },

    setLang(l) {
      this.lang = l //sessionStorage.getItem('lan')

      if (this.$route.name === "Home") {
        this.playLines()
      }
    },

    async loadLines() {
      // return new Promise(async resolve => {
      //   let records = await airtable.getKrishnaLines()
      //
      //   records.forEach(rec => {
      //     this.krishnaLines.push(rec.fields)
      //   })
      //   resolve('finished')
      // })
    },

    async playLines() {
      this.hasLinkAttached = false
      this.hasImgAttached = false
      this.$refs.audio ? (this.$refs.audio.src = null) : null
      this.$refs.imgAttached ? (this.$refs.imgAttached.src = null) : null
      this.$refs.urlAttached ? (this.$refs.urlAttached.href = null) : null

      if (this.language === "pt") {
        this.firstLine = this.krishnaLines[this.index].FirstLinePt
        this.secLine = this.krishnaLines[this.index].SecondLinePt
      } else {
        this.firstLine = this.krishnaLines[this.index].FirstLineEn
        this.secLine = this.krishnaLines[this.index].SecondLineEn
      }

      if (this.krishnaLines[this.index].attachment) {
        if (this.language === "pt") {
          for (let att of this.krishnaLines[this.index].attachment) {
            if (
              att.type.indexOf("audio") > -1 &&
              this.autoPlay &&
              this.$refs.audio &&
              (att.filename.indexOf(`l${this.index + 1}pt`) > -1 ||
                att.filename.indexOf(`l${this.index + 1}-both`) > -1)
            ) {
              this.$refs.audio.src = att.url

              this.$refs.audio.onpause = (event) => {
                this.checkIfImageToClick(event)
              }
            } else if (
              att.type.indexOf("image") > -1 &&
              this.$refs.imgAttached &&
              (att.filename.indexOf("pt") > -1 ||
                att.filename.indexOf("both-languages") > -1)
            ) {
              // this.$refs.mainView.classList.add('increase-min-height')
              this.$refs.imgAttached.src = att.url
              this.hasImgAttached = true
              this.checkImgWidth()
            }
          }
        } else {
          for (let att of this.krishnaLines[this.index].attachment) {
            if (
              att.type.indexOf("audio") > -1 &&
              this.autoPlay &&
              this.$refs.audio &&
              (att.filename.indexOf(`l${this.index + 1}en`) > -1 ||
                att.filename.indexOf(`l${this.index + 1}-both`) > -1)
            ) {
              this.$refs.audio.src = att.url
              this.$refs.audio.onpause = (event) => {
                this.checkIfImageToClick(event)
              }
            } else if (
              att.type.indexOf("image") > -1 &&
              this.$refs.imgAttached &&
              (att.filename.indexOf("en") > -1 ||
                att.filename.indexOf("both-languages") > -1)
            ) {
              // this.$refs.mainView.classList.add('increase-min-height')
              this.$refs.imgAttached.src = att.url
              this.hasImgAttached = true
              this.checkImgWidth()
            }
          }
        }

        setTimeout(async () => {
          if (!this.hasImgAttached) {
            // this.$refs.mainView.classList.remove('increase-min-height')
          }

          if (
            this.gotFirstInteraction &&
            this.autoPlay &&
            this.$refs.audio.src &&
            this.$refs.audio.src.indexOf("null") === -1
          ) {
            if (this.$refs.audio.error) {
              this.checkConditionsAndPlay()
            }
            await this.$refs.audio.play()
          } else {
            this.executeAfterInteraction = "play-audio"
          }
        }, 1000)
      }

      if (this.krishnaLines[this.index].links) {
        this.$refs.urlAttached.href = this.krishnaLines[this.index].links
        this.hasLinkAttached = true
      }
    },

    getIcon(type) {
      switch (type) {
        case "play-pause":
          if (this.autoPlay) return icons.pause
          else return icons.play
        case "prev":
          return icons.backward
        case "next":
          return icons.forward

        default:
          break
      }
    },
  },
}
</script>

<style scoped>
#img-anchor-container {
  margin: 1% auto;
  width: fit-content;
}

.center-image {
  position: relative;
}

.increase-min-height {
  min-height: 630px !important;
}

#home {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
  width: 90%;
  height: 90vh;
  margin: 3% 0;
}

button {
  width: 42vh;
}

.button-icon {
  width: 1.5rem;
}

.bubble {
  height: fit-content;
  width: fit-content;
  display: inline-block;
  position: relative;
  padding: 3vh 3vh;
  border-radius: 10px;
  border: 3px solid black;
  background: white;
  font-family: "Permanent Marker";
  clear: both;
}

.bubble.left {
  float: left;
  line-height: 25px;
  margin: 1%;
}

.bubble.right {
  float: right;
  /* margin: 1%; */
}

#krishna-img,
#img-container {
  width: 100%;
  max-width: 450px;
  max-height: 290px;
}

#control-buttons {
  width: 49%;
  /* bottom: 4%; */
  z-index: 1;
  display: flex;
  flex-direction: column;
  /* position: fixed; */
  pointer-events: none;
  justify-content: center;
}

audio {
  width: 100vh;
  min-height: 12% !important;
}

#controls-buttons-container {
  display: flex;
  flex-direction: column;
}

@media screen and (min-width: 768px) {
  .bubble.left {
    font-size: 20px;
  }

  #social-media-links {
    right: 85%;
    margin: 15px 0 0 0;
  }
}

@media screen and (min-width: 1200px) {
  .bubble.left {
    max-width: 55%;
    font-size: 25px;
  }
}

@media screen and (max-width: 768px) {
  #home {
    /* min-height: 80vh; */
    flex-direction: column;
  }

  #krishna-img {
    width: 48%;
  }

  .bubble:before {
    display: none;
  }

  audio {
    bottom: 10%;
  }

  button {
    width: 40%;
  }

  #control-buttons {
    width: 80%;
    bottom: 0%;
    position: fixed;
  }

  #controls-buttons-container {
    flex-direction: row;
    width: 67%;
  }
}

@media screen and (max-height: 490px) {
  #home {
    min-height: 540px;
  }
}

@media screen and (max-width: 500px) {
  #social-media-links {
    bottom: 25%;
  }

  #krishna-img {
    width: 85%;
    margin: 10% 0 1% 0;
  }

  button {
    width: 50%;
  }

  /* audio {
      width: 80%;
    } */

  .center-image {
    margin: 1% 0 0 0;
  }
}

@media screen and (max-width: 370px) {
  #social-media-links {
    bottom: 22%;
  }
}
#loading {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: xx-large;
  font-family: sans-serif;
}
#loading > div > div {
  padding: 2px;
}
.progress {
  width: 50vw;
  border: 1px solid black;
}
#progressbar {
  width: 0;
  transition: width ease-out 0.5s;
  height: 1em;
  background-color: #888;
  background-image: linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.5) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.5) 50%,
    rgba(255, 255, 255, 0.5) 75%,
    transparent 75%,
    transparent
  );
  background-size: 50px 50px;
  animation: progressanim 2s linear infinite;
}

@keyframes progressanim {
  0% {
    background-position: 50px 50px;
  }
  100% {
    background-position: 0 0;
  }
}
</style>